export default __webpack_public_path__ + "static/media/github-project.406659d4.gif";